import React from "react";
import WhiteButton from "../../components/Button/WhiteButton";
import styles from "../About/About.module.css";
import BlackButton from "../../components/Button/BlackButton";
import Link from "react-scroll/modules/components/Link";
import { useTranslation } from "react-i18next";
function About()
{
  const { t, i18n } = useTranslation("global");
  return (
    <>
      <div className={styles.main} id="about">
      <div className={styles.shape}></div>
        <div className={styles.shape2}></div>
        <hr />
        <p>
          {t("about.main")}

        </p>
      </div>{" "}
      <div className={styles.buttons}>
        <a href={t("about.cv")} target="_blank">
          {" "}
          <WhiteButton name={t("buttons.downloadCv")} />
        </a>
        <Link
          to="projects"
          spy={true}
          smooth={true}
          offset={-30}
          duration={500}
          activeClass="active"
        >
          {" "}
          <WhiteButton name={t("buttons.projects")} />
        </Link>
      </div>
    </>
  );
}
export default About;
